// components/MyResponses/MyResponsesList/index.tsx
import { Card, CardBody, Col, Input, Label, Row, Table } from 'reactstrap';
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader';
import { useFetchResponsesForParticipant } from '../../../hooks/participantResponses/useFetchResponsesForParticipant';
import ParticipantResponsesBody from './ParticipantResponsesBody';
import { useFetchGroups } from '../../../hooks/useFetchGroups';

export default function MyResponsesList() {
    const user = JSON.parse(localStorage.getItem('user') || '{}') as { id?: string; role?: string };

    const { userSpecificGroups = [] } = useFetchGroups(user?.id || '');

    const {
        reviews,
        total,
        loading,
        error,
        page,
        limit,
        setPage,
        setLimit,
        phase,
        setPhase,
        groupId,
        setGroupId,
        search,
        setSearch,
        reload
    } = useFetchResponsesForParticipant({ page: 1, limit: 10 });

    return (
        <Col xxl={12} xl={12} lg={12} md={12}>
            <Card>
                <CommonCardHeader title="My Submitted Responses" headClass="card-no-border pb-0" />
                <CardBody className="pt-0">
                    <Row className="gy-2 align-items-center mb-2">
                        <Col md={3}>
                            <Label className="d-flex align-items-center mb-0">Phase:
                                <Input type="select" value={phase} onChange={(e) => setPhase(e.target.value as any)} className="ms-2" style={{ maxWidth: 180 }}>
                                    <option value="all">all</option>
                                    <option value="pre">pre</option>
                                    <option value="during">during</option>
                                    <option value="post">post</option>
                                </Input>
                            </Label>
                        </Col>

                        {/* <Col md={3}>
                            <Label className="d-flex align-items-center mb-0">Group:
                                <Input type="select" value={groupId ?? ''} onChange={(e) => setGroupId(e.target.value || null)} className="ms-2" style={{ maxWidth: 240 }}>
                                    <option value="">— All groups —</option>
                                    {userSpecificGroups.map((g: any) => <option key={g._id ?? g.id} value={g._id ?? g.id}>{g.title}</option>)}
                                </Input>
                            </Label>
                        </Col> */}

                        {/* <Col md={3}>
              <Label className="d-flex align-items-center mb-0">Template:
                <Input type="select" value={templateId ?? ''} onChange={(e) => setTemplateId(e.target.value || null)} className="ms-2" style={{ maxWidth: 240 }}>
                  <option value="">— All templates —</option>
                  {templates.map((t: any) => <option key={t._id ?? t.id} value={t._id ?? t.id}>{t.title}</option>)}
                </Input>
              </Label>
            </Col> */}

                        <Col md={5}>
                            <Label className="d-flex align-items-center mb-0">Search:
                                <Input type="search" value={search} onChange={(e) => setSearch(e.target.value)} className="ms-2" placeholder="Search for a word in the title of an assignment or book review" />
                            </Label>
                        </Col>
                    </Row>

                    <div className="table-responsive theme-scrollbar">
                        <Table className="display table-bordernone dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>Assignment</th>
                                    <th>Group</th>
                                    <th>Template</th>
                                    <th>Phase summary</th>
                                    <th>Submitted At</th>
                                    <th className="text-end">View</th>
                                </tr>
                            </thead>

                            <ParticipantResponsesBody reviews={reviews} loading={loading} error={error} />
                        </Table>
                    </div>

                    <div className="d-flex align-items-center justify-content-between mt-3">
                        <div><small className="text-muted">Total: {total}</small></div>
                        <div className="d-flex align-items-center gap-2">
                            <select value={limit} onChange={(e) => { setLimit(Number(e.target.value)); setPage(1); }} className="form-select">
                                {[10, 20, 50].map(n => <option key={n} value={n}>{n} / page</option>)}
                            </select>
                            <nav aria-label="pagination">
                                <ul className="pagination mb-0">
                                    <li className={`page-item ${page <= 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setPage(Math.max(1, page - 1))}>Prev</button>
                                    </li>
                                    <li className="page-item disabled"><button className="page-link">{page}</button></li>
                                    <li className={`page-item ${page * limit >= total ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setPage(page + 1)}>Next</button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
}
